import React, { useEffect, useState } from "react"
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Grid,
    Autocomplete,
    Typography
} from "@mui/material"
import { Controller, useForm } from "react-hook-form"
import apiUrl from '../../configs/constant';
import axios from 'axios'
import { useToast } from "../ToastProvider";
interface Props {
    open: boolean
    data?: any
    onClose: () => void
}

export default function DialogEditHargaJasa({
    open,
    data,
    onClose
}: Props) {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const { showToast, hideToast } = useToast();

    useEffect(() => {
        if (!open) return
        if (data != null) {
            setValue('id', data.id)
            setValue('kode', data.kode)
            setValue('qty', data.qty)
            getHarga(data.id)
        } else {
            setValue('id', null)
        }
    }, [open])

    const getHarga = (id: any) => {
        let url = apiUrl.apiUrl + '/production/jasa-work-order/get-harga-work-order'

        axios
            .get(url, {
                params: {
                    wo_order_id: id,
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data

                    setValue('harga_jahit', data.harga_jahit[0]?.harga_jahit || 0)
                    setValue('harga_potong', data.harga_potong[0]?.harga_potong || 0)
                    setValue('harga_bordir', data.harga_bordir[0]?.harga_bordir || 0)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const {
        control,
        handleSubmit,
        formState: { errors },
        setValue,
        getValues,
        reset,
        watch
    } = useForm({
        defaultValues: {
            id: null,
            harga_jahit: "",
            harga_potong: "",
            harga_bordir: "",
            kode: "",
            qty: ""
        }
    })

    const onSubmit = (payload: any) => {
        const url = apiUrl.apiUrl + '/production/jasa-work-order/save'

        axios.post(url, payload, {
            headers: { Authorization: `Bearer ${token}` }
        }).then(res => {
            showToast(res.data.message, 'success')
            onClose()
        })
    }

    const formatNumber = (value: string | number) => {
        if (!value) return "";

        const str = String(value);

        // split decimal
        const [int, dec] = str.replace(/\./g, "").split(",");

        const formattedInt = Number(int || 0).toLocaleString("id-ID");

        return dec !== undefined ? `${formattedInt},${dec}` : formattedInt;
    };

    const parseNumber = (value: string) => {
        return value.replace(/\./g, "");
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogTitle sx={{ textAlign: 'center' }}>
                    Edit Biaya Jasa <br />{getValues('kode')} Qty : {getValues('qty')}
                </DialogTitle>

                <DialogContent dividers>
                    <Grid container spacing={2}>

                        <Grid item xs={12}>
                            <Controller
                                name="harga_jahit"
                                control={control}
                                rules={{ required: "Harga Jahit wajib diisi" }}
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        label="Harga Jahit"
                                        fullWidth
                                        value={formatNumber(field.value || "0")}
                                        inputProps={{ inputMode: "numeric" }}
                                        onChange={(e) => field.onChange(parseNumber(e.target.value))}
                                        error={!!errors.harga_jahit}
                                        helperText={errors.harga_jahit?.message as string}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Controller
                                name="harga_potong"
                                control={control}
                                rules={{ required: "Harga Potong wajib diisi" }}
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        label="Harga Potong"
                                        fullWidth
                                        value={formatNumber(field.value || "0")}
                                        inputProps={{ inputMode: "numeric" }}
                                        onChange={(e) => field.onChange(parseNumber(e.target.value))}
                                        error={!!errors.harga_potong}
                                        helperText={errors.harga_potong?.message as string}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Controller
                                name="harga_bordir"
                                control={control}
                                rules={{ required: "Harga Bordir wajib diisi" }}
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        label="Harga Bordir"
                                        fullWidth
                                        value={formatNumber(field.value || "0")}
                                        inputProps={{ inputMode: "numeric" }}
                                        onChange={(e) => field.onChange(parseNumber(e.target.value))}
                                        error={!!errors.harga_bordir}
                                        helperText={errors.harga_bordir?.message as string}
                                    />
                                )}
                            />
                        </Grid>

                    </Grid>
                </DialogContent>

                <DialogActions sx={{ p: 2 }}>
                    <Button
                        type="submit"
                        variant="contained"
                        fullWidth
                        size="large"
                    >
                        SIMPAN BIAYA
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    )
}